/* NYPH cut-to-size cart lock (2026-09-30). Cut lines are priced by quantity (1 unit = 1 sq ft). The product page sets quantity from the cut size but the cart lets a customer lower it (order 1117 paid for 2 sq ft on a 9 sq ft cut). This puts quantity back to the billed sq ft stored on the line and keeps the 4 sq ft setup line right. */
(function () {
  if (window.__nyphCutLock) return;
  window.__nyphCutLock = true;
  var SETUP_SQFT = 4;
  var SETUP_KEY = 'Birch setup';
  var SETUP_NOTE = 'First 4 sq ft of the order, charged twice (small-cut setup)';
  var busy = false, again = false, timer = null, inSync = false;
  function json(r) { return r.json(); }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(json); }
  function change(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: qty }) }).then(json);
  }
  function add(variantId, qty) {
    var props = {}; props[SETUP_KEY] = SETUP_NOTE;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: props }] }) }).then(json);
  }
  function refreshUi() {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (cart) {
        document.querySelectorAll('[data-cart-count],.cart-link__bubble-num,.cart-link__count,.site-header__cart-count,.cart-count').forEach(function (e) { e.textContent = cart.item_count; });
        try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, nyphCutLock: true } })); } catch (e) {}
        if (/^\/cart\/?$/.test(location.pathname)) { window.location.reload(); }
      });
    } catch (e) {}
  }
  function sync() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true; inSync = false;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var billed = 0, firstVid = null, fixes = [], setupLines = [], have = 0;
      items.forEach(function (it) {
        var p = it.properties || {};
        if (p['Cut size'] && p['Total sq ft']) {
          var t = parseInt(p['Total sq ft'], 10);
          if (t > 0) {
            billed += t;
            if (!firstVid) firstVid = it.variant_id;
            if (it.quantity !== t) fixes.push({ key: it.key, qty: t });
          }
        } else if (p[SETUP_KEY]) {
          setupLines.push(it); have += it.quantity;
        }
      });
      if (!billed && !setupLines.length) { return false; }
      var want = Math.min(SETUP_SQFT, billed);
      var chain = Promise.resolve();
      fixes.forEach(function (f) { chain = chain.then(function () { return change(f.key, f.qty); }); });
      if (have !== want) {
        if (setupLines.length) {
          setupLines.forEach(function (it, i) { chain = chain.then(function () { return change(it.key, i === 0 ? want : 0); }); });
        } else if (want > 0 && firstVid) {
          chain = chain.then(function () { return add(firstVid, want); });
        }
      }
      var changed = fixes.length > 0 || have !== want;
      return chain.then(function () { return changed; });
    }).then(function (changed) {
      busy = false; inSync = true;
      if (changed) refreshUi();
      if (again) { again = false; schedule(300); }
    }).catch(function () { busy = false; inSync = true; });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sync, ms == null ? 400 : ms); }
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments, url = '';
    try { url = String(args[0] && args[0].url ? args[0].url : args[0]); } catch (e) {}
    var p = origFetch.apply(this, args);
    if (/\/cart\/(change|update|add|clear)/.test(url)) {
      inSync = false;
      p.then(function () { if (!busy) schedule(450); }, function () {});
    }
    return p;
  };
  document.addEventListener('cart:updated', function (e) { if (e && e.detail && e.detail.nyphCutLock) return; schedule(450); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(200); });
  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest && ev.target.closest('[name=checkout],a[href*=\'/checkout\']');
    if (!el || inSync || ev.__nyphRetry) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    sync().then(function () {
      setTimeout(function () {
        inSync = true;
        try { var c = new MouseEvent('click', { bubbles: true, cancelable: true }); c.__nyphRetry = true; el.dispatchEvent(c); } catch (e) { el.click(); }
      }, 350);
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(300); });
  else schedule(300);
})();
